import type { PreviewInfo, PreviewUpdateData } from '@shared/api';

export const normalizePreviewValues = (question: string, answers: string[]): PreviewUpdateData => ({
  question: question.trim(),
  answers: answers.map((answer) => answer.trim()),
});

export const previewMatchesSearch = (preview: PreviewInfo, search: string) => {
  const normalizedSearch = search.trim().toLocaleLowerCase();
  if (!normalizedSearch) return true;

  return [preview.url, preview.question, ...preview.answers].some((value) =>
    value.toLocaleLowerCase().includes(normalizedSearch),
  );
};
